import { render, staticRenderFns } from "./SignatureModal.vue?vue&type=template&id=52edcbd5&scoped=true"
import script from "./SignatureModal.vue?vue&type=script&lang=js"
export * from "./SignatureModal.vue?vue&type=script&lang=js"
import style0 from "./SignatureModal.vue?vue&type=style&index=0&id=52edcbd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52edcbd5",
  null
  
)

export default component.exports